interface Settings {
  baseUrlDevServer: string;
  baseUrlTestServer: string;
  baseUrlProd: string;
}

const settings: Settings = {
  baseUrlDevServer: "http://localhost:3000/services",
  baseUrlTestServer: "https://newdevapi.roadian.com/services",
  baseUrlProd: "https://newdevapi.roadian.com/services",
};

export default settings;
